import React, { useState, useEffect } from 'react';
import { Autocomplete } from './Autocomplete';
import { errorTypeLookup } from './util';
import PlacesAutocomplete from 'react-places-autocomplete';
import useUserCoordinates from './hooks/useUserCoords';
const isNum = (x) => typeof x === 'number';
export const LocationSearch = (props) => {
    if (!(window === null || window === void 0 ? void 0 : window.google)) {
        return React.createElement("pre", null, "Error loading Google Places API");
    }
    const [address, setAddress] = useState('');
    const [placeLookupError, setPlaceLookupError] = useState({ error: false });
    const [searchOptions, setSearchOptions] = useState({});
    const [{ latitude: userLatitude, longitude: userLongitude }, fetchUserPosition,] = useUserCoordinates();
    useEffect(() => {
        if (isNum(userLatitude) && isNum(userLongitude)) {
            // set the search bias when user location is known
            setSearchOptions(Object.assign(Object.assign({}, searchOptions), { location: new google.maps.LatLng(userLatitude, userLongitude), radius: 5000 }));
        }
    }, [userLatitude, userLongitude]);
    useEffect(() => {
        fetchUserPosition();
    }, []);
    return (React.createElement(PlacesAutocomplete, { value: address, onChange: (value) => {
            setPlaceLookupError({ error: false, message: '' });
            setAddress(value);
            if (props.onChange) {
                props.onChange(value);
            }
        }, onError: (status, clearSuggestions) => {
            console.error('Error has occurred:', status);
            const matchedError = errorTypeLookup(status, props.errorMap);
            setPlaceLookupError(Object.assign({ error: true }, Object.assign({}, (matchedError ? { message: matchedError } : null))));
            clearSuggestions();
        }, debounce: 100, searchOptions: searchOptions }, ({ getInputProps, suggestions, getSuggestionItemProps, loading, }) => {
        return (React.createElement(Autocomplete, { results: suggestions.map((s) => ({
                label: s.description,
                value: s,
            })), loading: loading, error: placeLookupError.error, errorMessage: placeLookupError.message, onChange: (value) => getInputProps().onChange({ target: { value } }), onFocus: fetchUserPosition, resultsToDisplay: 5, onSelect: (suggestion) => 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getSuggestionItemProps(suggestion.value), label: props.label, description: props.description, name: props.name, inputPlaceholder: props.placeholder }));
    }));
};
//# sourceMappingURL=LocationSearch.js.map